module.exports = __webpack_public_path__ + "static/insta2-f8433bacb9bac08ff60d73d4756a57bb.png";